class OrizonBundle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-bundle-submit]');
    this.status = this.querySelector('[data-bundle-status]');
    this.button?.addEventListener('click', () => this.addBundle());
  }

  async addBundle() {
    const items = JSON.parse(this.dataset.items || '[]');
    if (!items.length || !this.button) return;
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.status.textContent = 'Adding your travel set…';
    this.status.classList.remove('is-error');
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'One or more items could not be added.');
      }
      window.location.assign(`${window.Shopify.routes.root}cart`);
    } catch (error) {
      this.status.textContent = error.message;
      this.status.classList.add('is-error');
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('orizon-bundle')) customElements.define('orizon-bundle', OrizonBundle);
